import React from "react";
import { Link } from "react-router-dom";
import { IMAGES, STATS } from "../../mock";

export default function AboutSection() {
  return (
    <section className="bg-cream py-28 relative">
      <div className="max-w-[1300px] mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Images */}
          <div className="relative reveal">
            <div className="img-zoom rounded-sm overflow-hidden">
              <img src={IMAGES.aboutPortrait} alt="Cosmetic care" className="w-full h-[540px] object-cover" />
            </div>
            <div className="img-zoom absolute -bottom-10 -right-4 w-48 h-64 rounded-sm overflow-hidden border-4 border-cream hidden md:block">
              <img src={IMAGES.facial2} alt="Treatment" className="w-full h-full object-cover" />
            </div>
            <div className="absolute -top-6 -left-6 w-24 h-24 border border-gold/50 hidden md:block" />
          </div>

          {/* Copy */}
          <div className="reveal">
            <div className="flex items-center gap-3 mb-6">
              <span className="gold-rule" />
              <span className="eyebrow text-gold">Welcome to Aesthetix MD</span>
            </div>
            <h2 className="font-display text-4xl lg:text-5xl font-light leading-tight text-ink">
              Where medical expertise meets <span className="italic text-gold">artful</span> beauty
            </h2>
            <p className="font-sans text-muted-ink text-[15px] leading-[1.9] mt-7">
              When it comes to your appearance, you deserve the very best care. We are a certified cosmetic clinic providing professional, safe and deeply personalised services across the Edmonton area.
            </p>
            <p className="font-sans text-muted-ink text-[15px] leading-[1.9] mt-4">
              From injectables and regenerative therapies to bespoke facials, every treatment is guided by a philosophy of subtlety, precision and genuine care.
            </p>
            <Link to="/about" className="inline-block btn-outline-dark mt-9">Learn More About Us</Link>
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 mt-28 reveal">
          {STATS.map((s) => (
            <div key={s.label} className="text-center border-t border-gold/30 pt-6">
              <div className="font-display text-5xl text-gold font-light">{s.value}</div>
              <div className="eyebrow text-muted-ink mt-3">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
